'use strict';

exports.__esModule = true;
exports.default = {
  LIKE: 'like',
  RECOMMEND: 'recommend'
};
//# sourceMappingURL=LikeAction.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/constants/LikeAction.js
// module id = 869
// module chunks = 67997519577666